'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useState } from 'react';
import { Image } from '@/components/client';
interface ThumbnailBackedImageProps {
  src: string;
  alt: string;
  thumbnailSrc?: string;
  loading?: 'eager' | 'lazy';
  preload?: boolean;
  fetchPriority?: 'high' | 'low' | 'auto';
}

//* 목록이 이미 받은 썸네일을 바닥에 깔고 히어로 해상도는 로드 뒤 페이드로 덮는다 — CDN 엣지 미스(0.3~0.5s) 동안 회색 대신 사진이 보인다
export const ThumbnailBackedImage = t0 => {
  const $ = _c(16);
  const {
    src,
    alt,
    thumbnailSrc,
    loading,
    preload,
    fetchPriority
  } = t0;
  const [isHeroLoaded, setIsHeroLoaded] = useState(false);
  let t1;
  if ($[0] !== thumbnailSrc) {
    t1 = thumbnailSrc ? <Image src={thumbnailSrc} alt="" fill={true} unoptimized={true} className="object-cover" loading="eager" /> : null;
    $[0] = thumbnailSrc;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = thumbnailSrc && "transition-opacity duration-200";
  const t3 = thumbnailSrc && !isHeroLoaded && "opacity-0";
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = cn("object-cover", t2, t3);
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsHeroLoaded(true);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== alt || $[7] !== fetchPriority || $[8] !== loading || $[9] !== preload || $[10] !== src || $[11] !== t4) {
    t6 = <Image src={src} alt={alt} fill={true} unoptimized={true} loading={loading} preload={preload} fetchPriority={fetchPriority} className={t4} onLoad={t5} />;
    $[6] = alt;
    $[7] = fetchPriority;
    $[8] = loading;
    $[9] = preload;
    $[10] = src;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t6) {
    t7 = <>{t1}{t6}</>;
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};